import { environmentVariable, resolveEnvironmentVariable } from '@/lib/env';

import { EVENTS } from '@/lib/constants';
import { EventBus } from '@/lib/event-bus';

const syncHost = () => {
  const host = window.location.host;
  if (host.includes('stage.x.mooncamp.com')) {
    return host.replace('stage', 'stage-subscription');
  }
  if (host.endsWith('-bumblebee.mooncamp-dev.com')) {
    return host.replace('-bumblebee.mooncamp-dev.com', '-vortex.mooncamp-dev.com');
  }
  return resolveEnvironmentVariable(environmentVariable.VORTEX_HOST);
};

let subscriptionChannel = null;

const protocol = 'sse'; // optionally 'ws'

const connect = ({ account, savedView }) => {
  if (protocol === 'sse') {
    const savedViewParam = savedView === undefined ? '' : `&savedViewId=${savedView.uid}`;
    const subscriptionUrl = `https://${syncHost()}/api/v1/subscribe?accountId=${account.uid}${savedViewParam}`;
    subscriptionChannel = new EventSource(subscriptionUrl, { withCredentials: true });
    return;
  }

  const subscriptionUrl = `wss://${syncHost()}/api/v1/subscribe`;
  subscriptionChannel = new WebSocket(subscriptionUrl);
};

const disconnect = () => {
  if (subscriptionChannel === null) {
    return;
  }

  subscriptionChannel.close();
  subscriptionChannel = null;
};

let connector = null;
let eventHandlers = [];

const initConnector = () => {
  eventHandlers = [];
  connector = new Promise((resolve) => {
    const handler = ({ account, savedView }) => { connect({ account, savedView }); resolve(); };
    eventHandlers.push(handler);
    EventBus.$on(EVENTS.SESSION.LOGIN, handler);
    EventBus.$on(EVENTS.SESSION.LOGIN_PUBLISHED_VIEW, handler);
  });
};

const initVortex = () => {
  initConnector();

  const resetConnection = () => {
    disconnect();
    eventHandlers.forEach((handler) => { EventBus.$off(EVENTS.SESSION.LOGIN, handler); });
    initConnector();
  };
  EventBus.$on(EVENTS.SESSION.LOGOUT, resetConnection);
  EventBus.$on(EVENTS.SESSION.SWITCH_ACCOUNT, resetConnection);
};

const vortex = () => connector.then(() => subscriptionChannel);

export default {
  initVortex,
  vortex,
};
